export default __webpack_public_path__ + "static/media/logo.e99e9e07.png";